import CONF from '../utils/conf';
import u from '../utils/Utils';
import du from '../utils/dom-utilities';

/**
 * [showElement description]
 * @param  {[type]} element [class name of an element]
 * @param  {[type]} parent  [element context]
 */
function showElement(element, parent) {
    du.queryAll(element, parent).forEach((item) => {
        item.classList.remove('tab-quarterly__hide');
        item.children[0].classList.remove('tab-quarterly__active');
    });
}

/**
* Activate or desactivate tab-quarterly buttons.
* @param  {boolean} bool
*/
function desactivateButton(bool, parent) {
    du.queryAll('.js-quarterly__button', parent).forEach((item) => {
        item.disabled = bool;
    });
}

/**
* Hide multiple element.
* @param  {string} class name of an element
* @param  {[type]} parent  [element context]
*/
function hideElement(element, parent) {
    du.queryAll(element, parent).forEach((item) => {
        item.classList.add('tab-quarterly__hide');
    });
}

/**
 * define height
 * @param  {[type]} parent context NodeList
 */
function defineHeight(parent) {
    if (!Modernizr.mq(`(min-width: ${u.em(CONF.mq.xs)}em)`)){
        var containerSize = du.outerHeight(parent.querySelector('.tab-quarterly__button'));
        containerSize += du.returnMaxOuterHeight('.tab-quarterly__container', parent);
        du.queryAll('.tab-quarterly__containers', parent).forEach((item) => {
            item.style.height = containerSize + 'px';
        });
    } else {
        du.queryAll('.tab-quarterly__containers', parent).forEach((item) => {
            item.removeAttribute('style');
        });
    }
}

/**
 * Show or hide element of tab-quarterly depending screen size.
 * @param  {[type]} parent  [element context]
 */
function buildTab(parent) {
    if (!Modernizr.mq(`(min-width: ${u.em(CONF.mq.md)}em)`)){
        showElement('.tab-quarterly__col', parent, true);
        desactivateButton(false, parent);
        var focusedTab = du.queryAll(':focus', parent);

        if (!focusedTab.length) {
            focusedTab = parent.getElementsByClassName('tab-quarterly__button');
        }

        hideElement('.tab-quarterly__container', parent);
        if (focusedTab[0].parentNode.children[1])  {
            focusedTab[0].parentNode.children[1].classList.remove('tab-quarterly__hide');
        }

        focusedTab[0].classList.add('tab-quarterly__active');
    } else {
        desactivateButton(true, parent);
        showElement('.tab-quarterly__col', parent, true);
        showElement('.tab-quarterly__container', parent);
    }
    defineHeight(parent);
};

function initTab() {
    var tabList = du.queryAll('.js-tab-quarterly');
        du.onEvent(window, 'optimized-resize', () => {
            tabList.forEach((uniqueTab) => {
                buildTab(uniqueTab);
            });
        });

    tabList.forEach((uniqueTab) => {
        buildTab(uniqueTab);
        du.queryAll('.tab-quarterly__button', uniqueTab).forEach((button) => {
            du.onEvents(button, 'touchstart click', (event) => {
                showElement('.tab-quarterly__col', uniqueTab);
                event.target.classList.add('tab-quarterly__active');
                hideElement('.tab-quarterly__container', uniqueTab);
                event.target.parentNode.children[1].classList.remove('tab-quarterly__hide');
            });
        });
    });
}
export default initTab;



// WEBPACK FOOTER //
// ./src/main/js/components/tabQuarterly.js